import debounce from "lodash/debounce";

import { CREATE_USER, CHECK_USER_LOGIN } from "../../gql/AuthQueries";

import {
  required,
  minLength,
  maxLength,
  email,
  // sameAs
} from "vuelidate/lib/validators";

export default {
  name: "signup-form",

  data() {
    return {
      login: "",
      password: "",
      // repeatPassword: "",
      agree: "",
      agentLicense: "",
      firmName: "",
      tspa: false,
      submitLoading: false,
      isPhone: false,
      skipCheckLoginQuery: true,
      checkLogin: ""
    };
  },

  props: {
    isBuyerRegistration: {
      type: Boolean,
      default: false
    }
  },

  mounted: function() {
    if (localStorage.getItem("signupAgentInfo")) {
      let signupAgentInfo = JSON.parse(localStorage.getItem("signupAgentInfo"));
      this.agentLicense = signupAgentInfo.licensse;
      this.firmName = signupAgentInfo.firmName;
    }
  },

  watch: {
    login(newValue) {
      let onlyNumber = newValue.match(/\d/g);
      if (onlyNumber && onlyNumber.join("").length > 9) {
        this.isPhone = /^[+]?[\s./0-9]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/g.test(
          newValue
        );
      } else {
        this.isPhone = false;
      }
    }
  },

  computed: {
    isLoginEmail() {
      return this.login.indexOf("@") > -1;
    }
  },

  validations() {
    let params = {
      login: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(256)
      },

      password: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(16)
      },

      // repeatPassword: {
      //   sameAsPassword: sameAs("password")
      // }

      // agree: {
      //   required
      // }
    };

    if (this.isLoginEmail) {
      params.login = {
        required,
        email,
        minLength: minLength(5),
        maxLength: maxLength(256)
      };
    }

    return params;
  },

  apollo: {
    checkLogin: {
      query: CHECK_USER_LOGIN,
      variables() {
        return {
          login: this.login
        };
      },

      skip() {
        return this.skipCheckLoginQuery;
      },

      result() {
        this.skipCheckLoginQuery = true;
      }
    }
  },

  methods: {
    changeAgree(value) {
      this.agree = value ? value : "";
    },

    handleCheckLogin: debounce(function() {
      this.skipCheckLoginQuery = false;
    }, 300),

    submitForm() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.submitLoading = true;

        this.$apollo
          .mutate({
            mutation: CREATE_USER,
            variables: {
              login: this.login,
              role: localStorage.getItem("signupAgentInfo") ? "agent" : "buyer",
              brokerName: this.firmName,
              licence: this.agentLicense,
              password: this.password,
              passwordConfirmation: this.password,
              tcpaAccepted: this.tspa,
              filters: localStorage.getItem("signupAgentInfo")
                ? []
                : this.$store.state.filters,
              propertyTypeId: parseInt(this.$store.state.propertyTypeId)
            }
          })
          .then(({ data: { signUp: { user } } }) => {
            this.submitLoading = false;
            localStorage.removeItem("searchParams");

            if (user.phone) {
              localStorage.setItem("signupPhone", user.phone);

              if (this.isBuyerRegistration) {
                this.$emit("goToConfirmationSlide", "phone");
              } else {
                this.$router.push({
                  name: "confirmation_phone"
                });
              }
            } else {
              localStorage.setItem("signupEmail", user.email);

              if (this.isBuyerRegistration) {
                this.$emit("goToConfirmationSlide", "email");
              } else {
                this.$router.push({
                  name: "confirmation_email"
                });
              }
            }
          })
          .catch(mutationError => {
            const errors = mutationError.graphQLErrors;

            for (let error in errors) {
              this.$toasted.error(errors[error].message);
            }

            this.submitLoading = false;
          });
      }
    }
  }
};
